import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import Vue from "vue";
import json from "../assets/mocks/produtos.json";

import { buscarTodosItens } from "@/api/ApiPegarItens";
import ApiDelivery from "@/api/ApisDelivery";
import Swal from "sweetalert2";
import { apiBuscarMotivosChamarGarcom } from "@/api/ApiChamarGarcon";
// import { gerarIdUnico } from "@/utils/GerarIdUnico";
/**
 * @module Store
 */
Vue.use(Vuex);
/**
 * Na primeira vez que os dados vem da api, eles sao setados aqui mas a pagina inicial HomeView.vue ainda nao carrega
 * por isso, na HomeView.vue usamos a resposta direta do axios ao inves de dados do store
 */
export default new Vuex.Store({
  /**
   * Aqui vem os plugins.
   * O unico plugin usado é createPersistedState() - para os dados persistirem mesmo quando o user da um refresh na pagina
   */
  plugins: [createPersistedState()],

  state: {
    loading: false,
    isMenuEstatico: false, //vem na url, no final "--estatico"
    porCartao: json["porCartao"],
    organizarPorColunas: false,
    mesa: json["mesa"],
    nomeTerminal: null,
    whatsappAtivo: false,
    numeroWhatsapp: "",
    numeroEmpresaFK: json["numeroEmpresaFK"],
    idgarcom: json["idgarcom"],
    codigoCentroResultado: json["codigoCentroResultado"],
    empresa: "",
    cnpj: "",
    idTerminal: 0,
    idUnicoPedido: "",
    endereco: json["endereco"],
    logo: "",
    cor1: "",
    cor2: "",
    backgroundImage: "",
    produtos: json["classes"],
    classeSelecionada: "",
    classeSelecionadaDescricao: "",
    itemSelecionado: {},
    motivosChamarGarcom: [],
    itensVenda: [],
    destaques: [],
    itensCarrinho: [],
    animarCarrinho: false,
    itemTemporario: [],
    etapaSelecionada: [],
    statusMesa: "",
    totalContaMesa: null,
    abaSelecionada: "cardapio",
    mostrarBarraBusca: false,
    itemBuscado: null,
    pizzaCobrarMaior: true,
    cpfCliente: "",
    nomeCliente: "",

    // para mostrar ponto da carne e perguntar se tem alergia (Hard Rock)
    isHardRock: false,

    //bottom bar enviar pedido
    onClickEnviarPedido: 0,

    // para saber se mostra a camera para escanear codigo de barras
    cartaoComLeitorCodigoBarras: false,
    cartaoComQrCode: false,

    // apenas pro delivery
    horaDeFuncionamentoDelivery: null,
    tipoCardapio: "delivery", // options: delivery / mesa / balcao
    casaAberta: true,
    deliveryEndereco: null,
    deliveryRetirarNoLocal: false,
    deliveryTaxas: null,
    deliveryTaxasDeTodosEnderecos: [],
    deliveryPedido: null,
    mp_public_key: null,
    mp_tem_pix: false,
    mp_tem_cartao: false,
    lista_bairros: [],
    deliveryValorMinimo: 0.0,
    dhPrevisaoEntregaAteAgora: null,
    dhPrevisaoEntregaFinal: null,
    deliveryAceitaRetirada: true,
    deliveryAceitaEntrega: true,
    balcaoTelefone: "",
  },

  mutations: {
    SET_HORA_DE_FUNCIONAMENTO_DELIVERY(state, payload) {
      state.horaDeFuncionamentoDelivery = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_TIPO_CARDAPIO(state, payload) {
      if (payload === true || payload === 'delivery') {
        state.tipoCardapio = 'delivery';
      } else if (payload === 'mesa' || payload === 'balcao') {
        state.tipoCardapio = payload;
      } else {
        state.tipoCardapio = 'mesa';
      }
    },
    SET_IS_DELIVERY(state, payload) {
      // compatibilidade: ainda recebe boolean para transição
      state.tipoCardapio = payload ? 'delivery' : 'mesa';
    },
    SET_ON_CLICK_ENVIAR_PEDIDO(state, payload) {
      state.onClickEnviarPedido = payload;
    },
    SET_EMPRESA(state, payload) {
      state.empresa = payload;
    },
    SET_POR_CARTAO(state, payload) {
      state.porCartao = payload;
    },
    SET_ORGANIZAR_POR_COLUNAS(state, payload) {
      state.organizarPorColunas = payload;
    },
    SET_MESA(state, payload) {
      state.mesa = payload;
    },
    SET_NOME_TERMINAL(state, payload) {
      state.nomeTerminal = payload;
    },
    SET_IDS(state, payload) {
      (state.cnpj = payload.cnpj.toString()),
        (state.idTerminal = payload.idTerminal.toString()),
        (state.numeroEmpresaFK = payload.numeroEmpresaFK),
        (state.idgarcom = payload.idgarcom),
        (state.codigoCentroResultado = payload.codigoCentroResultado);
    },
    SET_MOSTRAR_WHATSAPP(state, payload) {
      state.whatsappAtivo = payload;
    },
    SET_NUMERO_WHATSAPP(state, payload) {
      state.numeroWhatsapp = payload;
    },
    SET_ENDERECO(state, payload) {
      state.endereco = payload;
    },
    SET_PRODUTOS(state, payload) {
      state.produtos = payload;
    },
    SET_DESTAQUES(state, payload) {
      state.destaques = payload;
    },
    SET_LOGO(state, payload) {
      state.logo = payload;
    },
    SET_CORES(state, payload) {
      state.cor1 = payload.cor1;
      state.cor2 = payload.cor2;
      state.corTexto = payload.corTexto;
    },
    SET_COR_TEXTO_ESCURA(state, payload) {
      state.corDoTexto = payload.corDoTexto;
    },
    SET_BACKGROUND_IMAGE(state, payload) {
      state.backgroundImage = payload;
    },
    SET_IS_MENU_ESTATICO(state, payload) {
      state.isMenuEstatico = payload;
    },
    SET_CURRENT(state, payload) {
      state.currentStr = payload;
    },
    SET_CLASSE_SELECIONADA(state, payload) {
      state.classeSelecionada = payload.titulo;
      state.classeSelecionadaObservacoes = payload.observacoes;
      state.classeSelecionadaDescricao = payload.descricao;
    },
    SET_ITENS_VENDA(state, payload) {
      state.itensVenda = payload;
    },
    SET_ITEM_SELECIONADO(state, payload) {
      state.itemSelecionado = payload;
    },
    SET_ETAPA_SELECIONADA(state, payload) {
      state.etapaSelecionada = payload;
    },
    SET_ITENS_CARRINHO(state, payload) {
      state.itensCarrinho.push(payload);
      state.animarCarrinho = true;
      setTimeout(() => {
        state.animarCarrinho = false;
      }, 900);
      console.log("adicionando este item");
      const tempoDesteItem = payload.tempoEstimado ?? payload.item.tempoEstimado;
      console.log(`tempo deste item ${tempoDesteItem}`);
      console.log("-------------------------------------------------------------------------------------");
      if (Number(state.dhPrevisaoEntregaAteAgora ?? 0) < Number(tempoDesteItem)) {
        state.dhPrevisaoEntregaAteAgora = tempoDesteItem;
      }
    },

    SET_LIMPAR_ITENS_CARRINHO(state) {
      state.itensCarrinho = [];
      state.dhPrevisaoEntregaAteAgora = 0;
    },

    SET_CARTAO_LEITOR_CODIGO_BARRAS(state, payload) {
      state.cartaoComLeitorCodigoBarras = payload == "1" || payload == 1 ? true : false;
      state.cartaoComQrCode = payload == "2" || payload == 2 ? true : false;
    },

    SET_LIMPAR_TUDO(state) {
      state.itensCarrinho = [];
      state.produtos = [];
      state.classeSelecionada = "";
      state.itemSelecionado = {};
      state.itensVenda = [];
      state.destaques = [];
      state.itensCarrinho = [];
      state.animarCarrinho = false;
      state.itemTemporario = [];
      state.etapaSelecionada = [];
      state.idUnicoPedido = "";
    },

    SET_LIMPAR_QUASE_TUDO_REFRESH(state) {
      state.produtos = [];
      state.itensVenda = [];
      state.destaques = [];
    },

    SET_DELETAR_ITEM_CARRINHO(state, payload) {
      const index = state.itensCarrinho.indexOf(payload);
      if (index > -1) {
        // only splice array when item is found
        state.itensCarrinho.splice(index, 1); // 2nd parameter means remove one item only
      }
    },
    DELETAR_ITENS_CARRINHO_POR_IDS(state, payload) {
      payload.forEach((e) => {
        state.itensCarrinho = state.itensCarrinho.filter((f) => f.id != e);
      });
    },
    SET_MOTIVOS_CHAMAR_GARCOM(state, payload) {
      state.motivosChamarGarcom = payload;
    },
    SET_ITEM_TEMPORARIO(state, payload) {
      state.itemTemporario.push(payload);
    },
    SET_LIMPAR_ITEM_TEMPORARIO(state) {
      state.itemTemporario = [];
    },
    SET_STATUS_E_CONTA(state, payload) {
      (state.statusMesa = payload.statusMesa), (state.totalContaMesa = payload.totalContaMesa);
    },
    SET_ABA_SELECIONADA(state, payload) {
      state.abaSelecionada = payload;
    },
    SET_MOSTRAR_BARRA_BUSCA(state, payload) {
      state.mostrarBarraBusca = payload;
    },
    SET_ITEM_BUSCADO(state, payload) {
      state.itemBuscado = payload;
    },

    SET_DELIVERY_ENDERECO(state, payload) {
      state.deliveryEndereco = payload;
    },

    SET_DELIVERY_RETIRAR_NO_LOCAL(state, payload) {
      state.deliveryRetirarNoLocal = payload;
    },
    SET_DELIVERY_TAXAS(state, payload) {
      state.deliveryTaxas = payload;
    },
    SET_DELIVERY_TAXAS_DE_TODOS_ENDERECOS(state, payload) {
      state.deliveryTaxasDeTodosEnderecos = payload;
    },
    /**
     *
     * @param {*} state
     * @param {Array<string>} payload
     */
    SET_DELIVERY_BAIRROS(state, payload) {
      state.lista_bairros = payload.reverse();
    },
    SET_DH_PREVISAO_ENTREGA(state, payload) {
      state.dhPrevisaoEntregaFinal = payload;
    },
    SET_DELIVERY_PEDIDO(state, payload) {
      state.deliveryPedido = payload;
    },
    SET_CASA_ABERTA(state, payload) {
      state.casaAberta = payload;
    },
    SET_CPF_CLIENTE(state, payload) {
      state.cpfCliente = payload;
    },
    SET_NOME_CLIENTE(state, payload) {
      state.nomeCliente = payload;
    },
    SET_DELIVERY_VALOR_MINIMO(state, payload) {
      state.deliveryValorMinimo = payload;
    },
    SET_DELIVERY_ACEITA_RETIRADA_ENTREGA(state, payload) {
      state.deliveryAceitaEntrega = payload.temEntrega;
      state.deliveryAceitaRetirada = payload.temRetirada;
    },
    SET_BALCAO_TELEFONE(state, payload) {
      state.balcaoTelefone = payload;
    },
    SET_PIZZA_COBRAR_MAIOR(state, payload) {
      state.pizzaCobrarMaior = payload;
    },
    SET_IS_HARD_ROCK(state, cnpj) {
      if (cnpj == null || cnpj == undefined || cnpj.length == 0) {
        // vamos checar se eh baitnazha, que dai nao tem cnpj
        state.isHardRock = false;
      } else {

        /**
          esses sao os cnpjs de todos os hard rocks
                 
          cnpj = 41881480000124 - porto alegre
          cnpj = 19806073000101 - Curitiba
          cnpj = 29576141000139 - gramado
          cnpj = 53278014000138 - praia grande
          cnpj = 77789352000100 - monte carlo (NAO ENTRA AQUI)
          cnpj = 56157905000124 - itapema
          cnpj = 36946574000102 - floripa
          */

        if (
          // nossos cnpjs de test
          // cnpj.includes("00906885242592") || // meu
          // cnpj.includes("00906885270692") || // do olavo
          // hard rocks
          cnpj.includes("00906885787892") || // Elly
          cnpj.includes("00906885035392") || // Banco do fabio
          cnpj.includes("36946574000102") ||
          cnpj.includes("33641404000113") ||
          cnpj.includes("29300231000100") ||
          cnpj.includes("19806073000101") ||
          cnpj.includes("41881480000124") ||

          cnpj.includes("29576141000139") ||
          cnpj.includes("53278014000138") ||
          cnpj.includes("56157905000124") ||
          cnpj.includes("36946574000102")
        ) {
          state.isHardRock = true;
          document.documentElement.style.setProperty("--font-family", "'FontHardRock', sans-serif");

          sessionStorage.setItem("font-guardada-session", "FontHardRock");
          localStorage.setItem("hardrock", true);
        } else {
          state.isHardRock = false;
          document.documentElement.style.setProperty("--font-family", "'Roboto', sans-serif");

          sessionStorage.setItem("font-guardada-session", "Roboto");
          localStorage.setItem("hardrock", false);
        }
      }
    },
    SET_TEM_MERCADO_PAGO(state, payload) {
      if (payload == null) {
        state.mp_public_key = null;
      } else if (payload.public_key == null) {
        state.mp_public_key = null;
      } else {
        state.mp_public_key = payload.public_key;
      }
      if (state.tipoCardapio === 'delivery' || state.tipoCardapio === 'balcao') {
        if (payload.pagamento.temPix == true || payload.pagamento.temPix == "true") {
          state.mp_tem_pix = true;
        } else {
          state.mp_tem_pix = false;
        }
        if (payload.pagamento.temCartao == true || payload.pagamento.temCartao == "true") {
          state.mp_tem_cartao = true;
        } else {
          state.mp_tem_cartao = false;
        }
      }
    },
    SET_ID_UNICO_PEDIDO(state) {
      let alfanumerico = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
      let idUnicoPedid = "";
      for (let index = 0; index < 8; index++) {
        let random = Math.floor(Math.random() * alfanumerico.length - 1);
        idUnicoPedid += alfanumerico[random];
      }
      console.log("gerando id unico");
      console.log("id unico = " + idUnicoPedid);
      state.idUnicoPedido = idUnicoPedid;
    },


  },

  /**
   * Acoes e funcoes realizadas no Store
   */
  actions: {
    /**
     * @function buscarTudo()
     * @desc Metodo usado para consumir a API e pegar os primeiros dados do cliente com os produtos do cardapio
     * @param {*} state 
     * @returns Respone
     */
    async buscarTudo(state) {
      state.commit("SET_LIMPAR_TUDO");
      state.commit('SET_TIPO_CARDAPIO', 'mesa') //  mesa / balcao / delivery 
      return buscarTodosItens(this.state.tipoCardapio === 'delivery' || this.state.tipoCardapio === 'balcao', false).then((res) => {
        console.log("js9on itens")
        console.log(res)

        // limpar o local storage
        localStorage.clear();

        // commits feitos no state
        state.commit("SET_TIPO_CARDAPIO", this.state.tipoCardapio);
        state.commit("SET_EMPRESA", res.nomeFantasia);
        state.commit("SET_POR_CARTAO", res.formaTrabalho == "cartao" ? true : false); //TODO fix this
        // state.commit("SET_POR_CARTAO", true); //TODO fix this
        state.commit("SET_ORGANIZAR_POR_COLUNAS", res.organizarPorColunas ?? false);
        state.commit("SET_MESA", res.mesa);
        state.commit("SET_NOME_TERMINAL", res.nomeTerminal);
        state.commit("SET_IS_MENU_ESTATICO", res.isMenuEstatico ?? false); // vem na url, no final "--estatico"
        state.commit("SET_ENDERECO", res.endereco);
        state.commit("SET_HORA_DE_FUNCIONAMENTO_DELIVERY", res.deliveryHorarioFuncionamento);
        state.commit("SET_PRODUTOS", res.classes);
        state.commit("SET_DESTAQUES", res.destaques);
        state.commit("SET_LOGO", res.personalizacao.logo);
        state.commit("SET_CORES", { cor1: res.personalizacao.cor1, cor2: res.personalizacao.cor2, corTexto: res.personalizacao.corTextoEscura === '1' ? 'black' : 'white' });
        state.commit("SET_BACKGROUND_IMAGE", res.backgroundImage);
        state.commit("SET_PIZZA_COBRAR_MAIOR", res.pizzaCobrarMaior == null ? null : res.pizzaCobrarMaior.toString() == '0' ? false : true);
        state.commit("SET_IDS", { numeroEmpresaFK: res.numeroEmpresaFK, idgarcom: res.idgarcom, codigoCentroResultado: res.codigoCentroResultado, cnpj: res.cnpj, idTerminal: res.idTerminal });
        state.commit("SET_TEM_MERCADO_PAGO", res.mp);
        state.commit("SET_CARTAO_LEITOR_CODIGO_BARRAS", res.personalizacao.cartaoComLeitorCodigoBarras); // se for 0 == nada, 1 == barcode e 2 == qrcode
        state.commit("SET_DELIVERY_VALOR_MINIMO", res.deliveryValorMinimo);

        if (this.state.tipoCardapio === 'delivery') {
          state.commit("SET_NUMERO_WHATSAPP", res.numeroWhatsapp);
          state.commit("SET_DELIVERY_ACEITA_RETIRADA_ENTREGA", res.deliveryConfig);
        }

        // so para hard rock
        state.commit("SET_IS_HARD_ROCK", res.cnpj.toString());


        apiBuscarMotivosChamarGarcom(res.cnpj, res.idTerminal).then((resgarcom) => {
          let listaMotivos = []
          for (let mot of resgarcom) {
            listaMotivos.push(mot.motivo)
          }
          state.commit("SET_MOTIVOS_CHAMAR_GARCOM", listaMotivos);
        });

        if (this.state.tipoCardapio === 'delivery') {
          ApiDelivery.buscarBairrosAllfood(res.cnpj, res.numeroEmpresaFK).then((res) => {
            state.commit('SET_DELIVERY_BAIRROS', res)
          }).catch((err) => console.error(err));
        }

        this.dispatch("selecionarClasseInicial")
        this.dispatch("startIdUnicoDoPedido")
        return res;
      })
    },


    /**
     * @function setarCores()
     * @desc Metodo usado para setar todas as cores e logo definidas pelo usuario no allfood
     * @param {*} state 
     * @param {string} cor1 
     * @param {string} cor2 
     * @param {string} logo 
     * @returns Response
     */
    async setarCores(state, cor1, cor2, logo) {
      // state.commit("SET_CORES");
      state.commit("SET_LOGO", logo);
    },

    /**
     * @function darRefresh()
     * @param {*} state o current state
     * @returns {object} response
     */
    async darRefresh(state) {
      console.log("dando refresh")
      return buscarTodosItens(this.state.tipoCardapio === 'delivery', true).then((res) => {
        state.commit("SET_PRODUTOS", res.classes);
        state.commit("SET_LIMPAR_QUASE_TUDO_REFRESH");
        state.commit("SET_TIPO_CARDAPIO", this.state.tipoCardapio);
        state.commit("SET_PRODUTOS", res.classes);
        state.commit("SET_DESTAQUES", res.destaques);
        state.commit("SET_IDS", { numeroEmpresaFK: res.numeroEmpresaFK, idgarcom: res.idgarcom, codigoCentroResultado: res.codigoCentroResultado, cnpj: res.cnpj, idTerminal: res.idTerminal });
        this.dispatch("selecionarClasseInicial")
        return res;
      })
    },

    /**
     * 
     * @param {*} state 
     * @param {*} telefone telefone digitado
     */
    async enviarTelefone(state, telefone) {
      return new Promise((resolve, reject) => {
        if (telefone.length < 12 && telefone.length > 9) {
          state.commit('SET_LOADING', true)


          ApiDelivery.buscarCliente(state.state.cnpj, telefone)

            /** caso nao retorne erro, entao o cliente ja esta cadastrado. O retorno sera os dados do cliente */
            .then(res => {
              state.commit('SET_LOADING', false)

              const dadosEnderecos = Array.isArray(res.dadosEnderecos) ? res.dadosEnderecos : []
              console.log('dadosEnderecos',dadosEnderecos)
              console.log("Contar isso 377 SE tiver endereco tem que ir para os dados para entrega")
              // Se já tiver um deliveryEndereco no store, usa ele. Caso contrário, usa o primeiro endereço
              let enderecoPrincipal = null
              if (state.state.deliveryEndereco && state.state.deliveryEndereco.id) {
                enderecoPrincipal = dadosEnderecos.find(e => e.id === state.state.deliveryEndereco.id) ?? dadosEnderecos[0] ?? null
              } else {
                enderecoPrincipal = dadosEnderecos[0] ?? null
              }
              
              const retirarNoLocal = state.state.deliveryRetirarNoLocal === true

              /** setar endereco no STATE */
              // console.log("Saiu aqui 121")

              state.dispatch("setDeliveryEndereco", enderecoPrincipal)

              /** no fluxo de retirada no local nao precisamos de bairro/taxa de entrega */
              if (retirarNoLocal) {
                state.dispatch("setDeliveryTaxas", null)
                resolve({
                  dadosEnderecos: dadosEnderecos,
                  dadosPessoais: res.dadosPessoais,
                  delivery: null,
                });
                return
              }

              if (!enderecoPrincipal || !enderecoPrincipal.bairro) {
                state.dispatch("setDeliveryTaxas", "erro")
                reject(2424)
                return
              }

              /** Agora vamos buscar a taxa de entrega e ver se entregamos neste bairo */
              ApiDelivery.buscarTaxaDeEntrega(state.state.cnpj, state.state.numeroEmpresaFK, enderecoPrincipal.bairro)
                .then(tax => {
                  state.dispatch("setDeliveryTaxas", tax)
                  resolve({
                    dadosEnderecos: dadosEnderecos,
                    dadosPessoais: res.dadosPessoais,
                    delivery: tax,
                  });
                }).catch(err2 => {
                  console.error("Erro na taxa de entrega api :: " + err2);
                  state.dispatch("setDeliveryTaxas", "erro")
                  reject(2424)
                })
            })

            /** caso retorne erro 501 eh pq o cliente ainda nao foi cadastrado */
            .catch(err => {
              console.error("Erro buscar cliente pelo numero :: " + err);
              state.commit('SET_LOADING', false)

              /** vamos limpar o state caso ja tenha alguma coisa la */
              state.dispatch("setDeliveryTaxas", null)
              state.dispatch("setDeliveryEndereco", null)

              reject(501)
            })
        } else {
          Swal.fire({ title: "Telefone inválido" })
          reject("telefone invalido");
        }
      })

    },

    /**
     * @function selecionarClasseInicial()
     * @description vai selecionar a classe inicial,  que é a primeira da lista de classes
     */
    async selecionarClasseInicial() {
      let obj = this.state.produtos[0];
      let payload = {
        titulo: obj["nome"],
        observacoes: obj["observacoes"],
        descricao: obj["descricao"],
        itensVenda: obj["itensVenda"]
      }
      this.dispatch('setClasseSelecionada', payload)
    },

    setIsMenuEstatico(state, payload) {
      state.commit("SET_IS_MENU_ESTATICO", payload);
    },

    setOrganizarPorColunas(state, payload) {
      state.commit("SET_ORGANIZAR_POR_COLUNAS", payload);
    },

    setLimparTudo(state) {
      state.commit("SET_LIMPAR_TUDO");
    },

    setIsDelivery(state, payload) {
      // ainda suportado para compatibilidade: payload boolean ou string
      if (payload === true || payload === 'delivery') {
        state.commit("SET_TIPO_CARDAPIO", 'delivery');
      } else if (payload === false || payload === 'mesa' || payload === 'balcao') {
        state.commit("SET_TIPO_CARDAPIO", payload === false ? 'mesa' : payload);
      } else {
        state.commit("SET_TIPO_CARDAPIO", 'mesa');
      }
    },

    setCurrent(state, payload) {
      state.commit("SET_CURRENT", payload["age"])
    },
    /**
     * 
     * @function setClasseSelecionada()
     * @param {*} state deve trazer o estado inicial
     * @param {*} payload deve ser um objeto composto por {titulo: titulo da classe, itensVenda: itens da classe}
     */
    setClasseSelecionada(state, payload) {
      state.commit("SET_CLASSE_SELECIONADA", payload)
      state.commit("SET_ITENS_VENDA", payload.itensVenda)
    },
    setporCartao(state, payload) {
      state.commit("SET_POR_CARTAO", payload)
    },
    setItemSelecionado(state, payload) {
      state.commit("SET_ITEM_SELECIONADO", payload)
    },

    setEtapaSelecionada(state, payload) {
      state.commit("SET_ETAPA_SELECIONADA", payload)
    },

    setItensCarrinho(state, payload) {
      state.commit("SET_ITENS_CARRINHO", payload)
    },

    setDeletarItemCarrinho(state, payload) {
      state.commit("SET_DELETAR_ITEM_CARRINHO", payload)
    },

    /** para remover promocoes e que ja passaram do horario (e disponibilidade) */
    deletarItensCarrinhoPorIds(state, payload) {
      state.commit("DELETAR_ITENS_CARRINHO_POR_IDS", payload)
    },

    setItemTemporario(state, payload) {
      state.commit("SET_ITEM_TEMPORARIO", payload)
    },

    setLimparItemTemporario(state) {
      state.commit('SET_LIMPAR_ITEM_TEMPORARIO')
    },

    setAnimarCarrinho(state) {
      state.commit('SET_ANIMAR_CARRINHO')
    },

    setAbaSelecionada(state, payload) {
      state.commit('SET_ABA_SELECIONADA', payload)
      // Empurra estado no histórico do browser para que o botão voltar funcione entre abas.
      // 'loading' é transiente — não cria entrada de histórico.
      if (payload !== 'loading' && typeof window !== 'undefined') {
        window.history.pushState({ aba: payload }, '', window.location.href)
      }
    },

    setStatusEConta(state, payload) {
      state.commit('SET_STATUS_E_CONTA', payload)
    },

    setMostrarBarraBusca(state, payload) {
      if (payload == null) {
        state.commit('SET_MOSTRAR_BARRA_BUSCA', !this.state.mostrarBarraBusca)
        if (!this.state.mostrarBarraBusca == false) {
          state.commit("SET_ITENS_VENDA", [])
        }
      } else {
        state.commit('SET_MOSTRAR_BARRA_BUSCA', payload)
        if (payload == false) {
          state.commit("SET_ITENS_VENDA", [])
        }
      }
    },
    setItemBuscado(state, payload) {
      if (payload.length != 0) {
        let todasClases = this.state.produtos
        let itensBuscados = []
        for (var i = 0; i < todasClases.length; i++) {
          for (var ii = 0; ii < todasClases[i].itensVenda.length; ii++) {
            if (todasClases[i].itensVenda[ii].nome.toLowerCase().includes(payload.toLowerCase())) {
              itensBuscados.push(todasClases[i].itensVenda[ii])
            }
          }
        }
        state.commit("SET_ITENS_VENDA", itensBuscados)
        state.commit('SET_ITEM_BUSCADO', payload)
      } else {
        state.commit("SET_ITENS_VENDA", [])
        state.commit('SET_ITEM_BUSCADO', payload)
      }
    },
    setDeliveryEndereco(state, payload) {
      state.commit('SET_DELIVERY_ENDERECO', payload)
    },
    setDeliveryRetirarNoLocal(state, payload) {
      state.commit('SET_DELIVERY_RETIRAR_NO_LOCAL', payload)
    },
    setDeliveryTaxas(state, payload) {
      state.commit('SET_DELIVERY_TAXAS', payload)
    },
    setDeliveryTaxasDeTodosEnderecos(state, payload) {
      state.commit('SET_DELIVERY_TAXAS_DE_TODOS_ENDERECOS', payload)
    },
    setDeliveryDhPrevisaoEntrega(state, payload) {
      state.commit('SET_DH_PREVISAO_ENTREGA', payload)
    },
    setDeliveryPedido(state, payload) {
      state.commit('SET_DELIVERY_PEDIDO', payload)
    },
    setOnCLickEnviarPedido(state) {
      console.log(state.state.onClickEnviarPedido)
      state.commit('SET_ON_CLICK_ENVIAR_PEDIDO', state.state.onClickEnviarPedido + 1)
    },
    setCasaAberta(state, payload) {
      state.commit('SET_CASA_ABERTA', payload)
    },

    setCpfCliente(state, payload) {
      state.commit('SET_CPF_CLIENTE', payload);
    },

    setBalcaoTelefone(state, payload) {
      state.commit('SET_BALCAO_TELEFONE', payload);
    },
    
    setNomeCliente(state, payload) {
      state.commit('SET_NOME_CLIENTE', payload);
    },

    startIdUnicoDoPedido(state) {
      state.commit('SET_ID_UNICO_PEDIDO')
    },


  },
  modules: {},

  getters: {
    getEmpresa(state) {
      return state.empresa;
    },
    getCurrentStr(state) {
      return state.currentStr;
    },
    getItensVenda(state) {
      return state.itensVenda;
    },
    getItensCarrinho(state) {
      return state.itensCarrinho;
    },
    getItemTemporario(state) {
      return state.itemTemporario;
    },
    getCasaAberta(state) {
      return state.casaAberta;
    },
    getTipoCardapio(state) {
      return state.tipoCardapio;
    },
    getIsDelivery(state) {
      return state.tipoCardapio === 'delivery';
    }
  }
})
